<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        시차근무신청
      </v-col>
    </v-row>
    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field label="신청구분" v-model="codeNm" readonly></v-text-field>
      <v-text-field
        label="신청구분코드"
        v-model="codeCd"
        readonly
        v-show="false"
      ></v-text-field>
      <v-text-field label="기준일자" v-model="ymd" readonly></v-text-field>
      <v-text-field
        label="기준일자 근무유형"
        v-model="workOrgNm"
        readonly
      ></v-text-field>
      <v-text-field label="신청사유" v-model="note"></v-text-field>
      <v-text-field
        label="신청단위"
        v-model="dayGubunNm"
        @click="applLevelSheet1 = !applLevelSheet1"
        class="bottom--box"
        append-icon="mdi-chevron-right"
        readonly
      ></v-text-field>
      <v-text-field
        label="신청단위코드"
        v-model="dayGubunCd"
        @click="applLevelSheet1 = !applLevelSheet1"
        class="bottom--box"
        append-icon="mdi-chevron-right"
        v-show="false"
      ></v-text-field>
      <v-text-field
        label="기간 및 시간을 선택해주세요"
        v-model="date"
        readonly
        append-icon="mdi-chevron-right"
        @click="goDaySetting"
      ></v-text-field>
      <v-text-field
        label="비상연락망"
        v-model="phoneNo"
        @change="setPhoneNo"
      ></v-text-field>
      <div class="borderLine-wrap" v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <bgf-attach-file-add ref="bgfAttachFile" />
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
    <bottom-select
      :flag="applLevelSheet1"
      :list="codeList1"
      :title="selecttitle1"
      @selectItem="changeApplLine1"
    ></bottom-select>
    <bgf-attach-file-bottom-select
      :flag="fileFlag"
      @selectItem="changeFile"
    ></bgf-attach-file-bottom-select>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg/
import routerNames from '@/const/routerConstants';
import { getWorkScheduleAppDetWorkOrg, getDayGubun, getWorkScheduleApplYn } from '@/api/workStatus';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import BottomSelect from '@/components/application/form/BottomSelect.vue';

import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import BgfAttachFileBottomSelect from '@/components/application/form/BgfAttachFileBottomSelect.vue';

export default {
  data: () => ({
    codeNm: '',
    codeCd: '',
    ymd: '',
    applLevelSheet1: false, // 용도 화면플래그
    selecttitle1: '신청단위',
    codeList1: [],
    note: '',
    workGrpCd: '',
    workOrgCd: '',
    workOrgNm: '',
    intervalCd: '',
    termGubun: '',
    workType: '',
    date: '',
    phoneNo: '',
    dayGubunCd: '',
    dayGrcodeCd: '',
    dayGubunNm: '',
    saveListUpd: [],
    saveListData: [],
    fileShow: true,
    fileFlag: false,
  }),

  components: {
    IconApprovalDoc,
    BottomSelect,
    BgfAttachFileBottomSelect,
    BgfAttachFileAdd,
  },

  computed: {
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
    ]),
    ...mapGetters([
      'GET_CODE',
      'GET_CODE_NM',
      'GET_USER_DATA',
      'GET_WORK_TYPE_CD',
      'GET_WORK_TYPE_NM',
      'GET_DAY_GUBUN_CD',
      'GET_DAY_GUBUN_NM',
      'GET_NOTE',
      'GET_PHONE_NO',
      'GET_DATE',
      'GET_FILE_SEQ',
      'GET_WORK_SCHEDULE_TIME_SAVE_UPD',
    ]),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },

  methods: {
    changeFile(levelObj) {
      if (levelObj === 'C') {
        this.$refs.bgfAttachFile.callCamera();
      } else if (levelObj === 'G') {
        this.$refs.bgfAttachFile.callGallery();
      }

      this.fileFlag = false;
    },

    async changeApplLine1(levelObj) {
      this.dayGubunCd = levelObj.code;
      this.dayGubunNm = levelObj.codeNm;

      // 대상자명선택화면닫기
      this.applLevelSheet1 = false;
      this.$store.commit('SET_DAY_GUBUN_CD', this.dayGubunCd);
      this.$store.commit('SET_DAY_GUBUN_NM', this.dayGubunNm);
      this.$store.commit('SET_NOTE', this.note);
      this.$store.commit('SET_DATE', this.date);
      this.$store.commit('SET_PHONE_NO', this.phoneNo);

      let year = dayjs(this.ymd).format('YYYY');
      let month = dayjs(this.ymd).format('MM') ;
      let firstDay = new Date(year, month - 1, 1);
      let lastDay = new Date(year, month - 1 + Number(this.dayGubunCd), 0);

      this.date =
        dayjs(firstDay).format('YYYY-MM-DD') +
        ' ~ ' +
        dayjs(lastDay).format('YYYY-MM-DD');

      this.$store.commit('SET_DATE', this.date);

      this.goDaySetting();
    },

    goDaySetting() {
      this.$store.commit('SET_NOTE', this.note);
      this.$store.commit('SET_DATE', this.date);
      this.$store.commit('SET_PHONE_NO', this.phoneNo);
      if (this.date.trim() !== '') {
        /*
        if (this.GET_FILE_SEQ !== '') {
          this.$store.commit('SET_FILE_SEQ', this.GET_FILE_SEQ);
        }
        */

        this.$router.push(routerNames.WorkScheduleTime3);
      } else {
        alert('신청단위를 선택해 주세요');
        return;
      }
    },

    setPhoneNo() {
      this.$store.commit('SET_PHONE_NO', this.phoneNo);
    },

    async applovalPage() {
      if (this.note.trim() === '') {
        alert('신청사유를 입력해 주세요');
        return;
      }

      if (this.dayGubunCd.trim() === '') {
        alert('신청단위를 선택해주세요');
        return;
      }

      if (this.date.trim() === '') {
        alert('기간 및 시간을 선택해주세요');
        return;
      }

      if (this.phoneNo.trim() === '') {
        alert('비상연락망을 입력해 주세요');
        return;
      }

      if (this.GET_UI_INFO.fileEssentialYn === 'Y') {
        if(this.GET_FILE_SEQ === '') {
          alert('파일 첨부는 필수 입니다');
          return;
        }
      }

      this.saveListUpd = this.GET_WORK_SCHEDULE_TIME_SAVE_UPD;

      for (let i = 0; i < this.saveListUpd.length; i++) {
        if (
          this.saveListUpd[i].bfTimeCd != null &&
          this.saveListUpd[i].afTimeCd != null
        ) {
          this.saveListData.push(this.saveListUpd[i]);
        }
      }

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        ssnSabun: this.GET_USER_DATA.ssnSabun,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        applTypeCd: '10', //본인신청
        workGrpCd: this.workGrpCd,
        workOrgCd: this.workOrgCd,
        intervalCd: this.intervalCd,
        dayGubunCd: this.dayGubunCd,
        ymd: this.ymd,
        note: this.note,
        phoneNo: this.phoneNo,
        reasonCd: this.GET_WORK_TYPE_CD,
        searchSYmd: this.date
          .split('~')[0]
          .replaceAll('-', '')
          .replaceAll(' ', ''),
        searchEYmd: this.date
          .split('~')[1]
          .replaceAll('-', '')
          .replaceAll(' ', ''),
        saveListData: this.saveListData,
      };


      if (this.saveListData.length === 0) {
        alert('신청할 내용이 없습니다.');
        return;
      }

      const param = {
        sYmd : this.ymd.replaceAll('-', ''),
      }

      let res = await getWorkScheduleApplYn(param);

      if (res.data.data.chk === 'Y') {
        alert("해당 기간에( 근태/휴가신청 )가 신청 중에 있습니다.");
        return;
      }

      // console.log('this.saveListData : '+JSON.stringify(this.saveListData));

      // eslint-disable-next-line no-unreachable
      this.$store.commit('SET_NOTE', this.note);
      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_WORK_SCHEDULE_TIME_PARAMS', params);
      this.$router.push(routerNames.ApprovalLine);
    },
  },

  async mounted() {
    this.code = this.GET_WORK_TYPE_CD;
    this.codeNm = this.GET_WORK_TYPE_NM;
    this.ymd = this.GET_S_YMD;

	  // 2025.05.19 JKT. 네트웍스 예외처리 추가 - 매월1~20일까지는 기준일자가 익월이고, 매월21~말일까지는 기준일자가 익익월이다.
    if( this.GET_USER_DATA.ssnEnterCd =='12')
    {
       let checkMinYmd = "";
      if( dayjs().date() <= '20' )
      {
         checkMinYmd = dayjs().add(1,'month').startOf('month').format('YYYYMMDD');

      }else
      {
         checkMinYmd = dayjs().add(2,'month').startOf('month').format('YYYYMMDD');
      }
      
       this.ymd = checkMinYmd;         
    }

    this.dayGubunCd = this.GET_DAY_GUBUN_CD;
    this.dayGubunNm = this.GET_DAY_GUBUN_NM;
    this.note = this.GET_NOTE;
    this.date = this.GET_DATE;
    this.phoneNo = this.GET_PHONE_NO;

    let params = {
      ymd: this.ymd, //dayjs().format('YYYY-MM-DD'),
    };

    let response = await getWorkScheduleAppDetWorkOrg(params);
    if (response.data.data === null) {
      alert(
        this.ymd +
          '에 근무스케쥴이 생성되지 않았습니다.\n담당자에게 문의 해주세요.',
      );

      this.$router.go(-1);
      return;
    }

    this.workGrpCd = response.data.data.workGrpCd;
    this.workOrgCd = response.data.data.workOrgCd;
    this.workOrgNm = response.data.data.workOrgNm;
    this.intervalCd = response.data.data.intervalCd;
    this.termGubun = response.data.data.termGubun;
    this.workType = response.data.data.workType;

    const workScheduleTimeData = {
      workGrpCd: this.workGrpCd,
      workOrgCd: this.workOrgCd,
      workOrgNm: this.workOrgNm,
      intervalCd: this.intervalCd,
      termGubun: this.termGubun,
      workType: this.workType,
    };

    this.$store.commit('setWorkScheduleTimeParam', workScheduleTimeData);

    params.dayGrcodeCd = response.data.data.dayGrcodeCd;
    response = await getDayGubun(params);
    this.codeList1 = response.data.data;

    if (this.GET_WORK_TYPE_CD === '50' || this.GET_WORK_TYPE_CD === '80') {
      this.codeList1.splice(3, 6);
    }

    if (this.GET_UI_INFO.fileYn === 'N') {
      this.fileShow = false;
    }
  },
};
</script>

<style></style>
